<script module>
    export { default as layout } from '../layouts/AppLayout.svelte';
</script>

<script lang="ts">
    let { content } = $props();
</script>

<svelte:head>
    <title>Privacy Policy — Case of the Day</title>
</svelte:head>

<div class="max-w-3xl mx-auto">
        <h1 class="text-3xl font-bold text-gray-100 mb-6">Privacy Policy</h1>
        <p class="text-sm text-gray-500 mb-8">Updated March 16, 2026.</p>

        <div class="prose prose-invert prose-gray max-w-none">
            <!-- eslint-disable-next-line svelte/no-at-html-tags -->
            {@html content}
        </div>
    </div>
